import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { getParameterByName, isEmpty } from '@Views/utils/StringUtils';
import { niceCheckDecode, callService } from '@Views/utils/ServiceUtils';

import EmploymentWrite0 from './comp/EmploymentWrite0'
import EmploymentWrite1 from './comp/EmploymentWrite1'
import EmploymentWrite2 from './comp/EmploymentWrite2'
import EmploymentWrite3 from './comp/EmploymentWrite3'

const EmploymentWrite = ({ msg }: any) => {

    const history = useHistory();

    const params: any = useParams();

    const [niceInfo, setNiceInfo] = useState<any>();

    let [svyrEmplySpprrDetail, setSvyrEmplySpprrDetail] = useState<any>({});

    const [pageNo, setPageNo] = useState<number>(1);

    const niceInfoCheck = async () => {
        const win: any = window;
        const encodeData: any = getParameterByName("EncodeData");

        if (isEmpty(niceInfo)) {
            if (win.opener) {
                win.opener.location = win.location.href;
                win.close();
            } else {
                if (isEmpty(encodeData) === false) {
                    const info = await niceCheckDecode(encodeData);

                    if (info) {
                        setNiceInfo(info);

                        svyrEmplySpprrDetail['svyrNm'] = info['name'];
                        svyrEmplySpprrDetail['bthymd'] = info['birthdate'];
                        setSvyrEmplySpprrDetail({ ...svyrEmplySpprrDetail });
                    }
                } else {
                    history.goBack();
                }
            }
        }
    }

    useEffect(() => {

        // 1. 공고문번호 파라미터 여부 체크
        if (isEmpty(params['svyrEmplyPbanNo'])) {
            history.goBack();
        }

        // 2. 실명인증 체크
        niceInfoCheck();
        // svyrEmplySpprrDetail['svyrNm'] = '김강훈';
        // svyrEmplySpprrDetail['hopTrmStYmd'] = '20241220';
        // svyrEmplySpprrDetail['hopTrmEndYmd'] = '20241231';
        // svyrEmplySpprrDetail['bthymd'] = '19900225';
        // svyrEmplySpprrDetail['strnmZpcd'] = '11111';
        // svyrEmplySpprrDetail['strnmAddr'] = '주소1';
        // svyrEmplySpprrDetail['strnmDtlAddr'] = '주소상세';
        // svyrEmplySpprrDetail['mblTelno'] = '01059100235';
        // svyrEmplySpprrDetail['cntctEaddr'] = 'test@naver.com';
        // setSvyrEmplySpprrDetail({ ...svyrEmplySpprrDetail });

    }, []);

    return (
        <>
            {
                pageNo === 1 ?
                    <EmploymentWrite1 msg={msg} history={history} setPageNo={setPageNo} pageNo={pageNo} svyrEmplyPbanNo={params['svyrEmplyPbanNo']} svyrEmplySpprrDetail={svyrEmplySpprrDetail} />
                    :
                    pageNo === 2 ?
                        <EmploymentWrite2 msg={msg} history={history} setPageNo={setPageNo} svyrEmplyPbanNo={params['svyrEmplyPbanNo']} svyrEmplySpprrDetail={svyrEmplySpprrDetail} />
                        :
                        pageNo === 3 ?
                            <EmploymentWrite3 msg={msg} history={history} setPageNo={setPageNo} svyrEmplyPbanNo={params['svyrEmplyPbanNo']} svyrEmplySpprrDetail={svyrEmplySpprrDetail} />
                            :
                            pageNo === 0 &&
                            <EmploymentWrite0 msg={msg} history={history} setPageNo={setPageNo} svyrEmplyPbanNo={params['svyrEmplyPbanNo']} svyrEmplySpprrDetail={svyrEmplySpprrDetail} />
            }
        </>
    );

}

export default EmploymentWrite;